import React from "react";
import "../styles/About.css";

const stats = [
  { value: "7+", label: "Industry Courses" },
  { value: "500+", label: "Learners Trained" },
  { value: "95%", label: "Placement Support" },
  { value: "50+", label: "Hands-on Projects" },
];

const features = [
  { icon: "⚡", title: "Hands-On Projects", desc: "Build real-world projects and practical experience." },
  { icon: "🎯", title: "Expert-Led Training", desc: "Learn directly from experienced industry engineers." },
  { icon: "🚀", title: "Career Guidance", desc: "Get support for interviews and career growth." },
  { icon: "☁️", title: "Industry Skills", desc: "Learn technologies that companies use today." },
];

const team = [
  { icon: "CE", label: "Cloud Experts" },
  { icon: "DO", label: "DevOps Engineers" },
  { icon: "SD", label: "Software Developers" },
  { icon: "TT", label: "Technical Trainers" },
  { icon: "CM", label: "Career Coaches" },
  { icon: "ST", label: "Support Team" },
];

const engineers = [
  {
    initials: "CE",
    name: "Cloud Engineer",
    role: "Cloud Technology Expert",
    desc: "Guides learners in cloud infrastructure and deployment.",
  },
  {
    initials: "DE",
    name: "DevOps Engineer",
    role: "Automation Specialist",
    desc: "Teaches CI/CD, automation, monitoring, and DevOps practices.",
  },
  {
    initials: "FS",
    name: "Full Stack Engineer",
    role: "Full Stack Expert",
    desc: "Helps students build modern web applications and APIs.",
  },
];

export default function About({ navigate, embedded = false }) {
  return (
    <div id="about" className={`about-page${embedded ? " about-embedded" : ""}`}>
      <section className="about-hero">
        <div className="about-hero-glow" aria-hidden />
        <p className="section-kicker">About Us</p>
        <h1>Building Skills for Tomorrow&apos;s Technology Careers</h1>
        <p>
          Confideo Cloud & Code helps students and professionals learn practical
          technology skills through hands-on training, projects, and expert guidance.
        </p>
      </section>

      <section className="section about-stats-section">
        <div className="about-stats">
          {stats.map((item) => (
            <div className="about-stat-card" key={item.label}>
              <span className="about-stat-value">{item.value}</span>
              <span className="about-stat-label">{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="about-panel">
          <p className="section-kicker">Who We Are</p>
          <h2>Practical Cloud & DevOps Training</h2>
          <p>
            We focus on job-ready skills — not just theory. From AWS and GCP to
            DevOps pipelines and GenAI, every program is built around real projects,
            instructor feedback, and career outcomes.
          </p>
        </div>

        <div className="about-grid">
          <div className="about-box">
            <h3>Our Mission</h3>
            <p>
              Provide industry-focused training that helps learners gain confidence,
              practical knowledge, and job-ready skills.
            </p>
          </div>
          <div className="about-box">
            <h3>Our Vision</h3>
            <p>
              Become a trusted learning platform that bridges the gap between
              education and industry requirements.
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="about-panel">
          <p className="section-kicker">Why Choose Us</p>
          <h2>Learn Beyond Theory</h2>
        </div>

        <div className="about-features">
          {features.map((item) => (
            <div className="feature-card" key={item.title}>
              <span className="feature-icon" aria-hidden>{item.icon}</span>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section about-journey">
        <div className="about-panel">
          <p className="section-kicker">Your Learning Path</p>
          <h2>From Beginner to Job-Ready</h2>
        </div>
        <div className="about-steps">
          <div className="about-step">
            <span className="about-step-num">01</span>
            <h4>Enroll &amp; Learn</h4>
            <p>Join live sessions and follow structured modules with instructor support.</p>
          </div>
          <div className="about-step">
            <span className="about-step-num">02</span>
            <h4>Build Projects</h4>
            <p>Complete hands-on labs and portfolio projects on real cloud stacks.</p>
          </div>
          <div className="about-step">
            <span className="about-step-num">03</span>
            <h4>Get Placed</h4>
            <p>Resume reviews, mock interviews, and placement guidance to land roles.</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="about-panel">
          <p className="section-kicker">Our Team</p>
          <h2>The People Behind Confideo</h2>
        </div>

        <div className="team-grid">
          {team.map((item) => (
            <div className="team-card" key={item.label}>
              <div className="team-avatar">{item.icon}</div>
              <h4>{item.label}</h4>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="about-panel">
          <p className="section-kicker">Meet Our Engineers</p>
          <h2>Learn From Industry Professionals</h2>
        </div>

        <div className="expert-grid">
          {engineers.map((item) => (
            <div className="expert-card" key={item.name}>
              <div className="expert-avatar">{item.initials}</div>
              <h4>{item.name}</h4>
              <span>{item.role}</span>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section about-cta-section">
        <div className="about-cta">
          <h2>Ready to start your cloud journey?</h2>
          <p>Explore our courses and book a free demo with our team.</p>
          <div className="about-cta-actions">
            <button
              type="button"
              className="btn-primary"
              onClick={() => (embedded ? document.getElementById("courses")?.scrollIntoView({ behavior: "smooth" }) : navigate("/courses"))}
            >
              View Courses
            </button>
            <button
              type="button"
              className="about-cta-secondary"
              onClick={() => (embedded ? document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }) : navigate("/contact"))}
            >
              Contact Us
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
